// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__f8Bgw","alertIcon":"ConfirmModal_alertIcon__9VO7k"};